import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useEmptyViewStyles = makeStyles(
  (theme: Theme) => {
    return {
      emptyContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '16rem',
      },
      emptyItems: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '0.75rem',
        width: '19rem',
      },
      emptyHeading: {
        color:
          theme.palette.mode === 'dark'
            ? 'var(--xlrt-color-ui-white)'
            : 'var(--xlrt-color-ui-gray20)',
        fontSize: '1.25rem',
        fontWeight: 700,
        textAlign: 'center',
        fontStyle: 'normal',
        lineHeight: '100%',
      },
      emptyDescription: {
        color:
          theme.palette.mode === 'dark'
            ? 'var(--xlrt-color-ui-gray75)'
            : 'var(--xlrt-color-ui-gray45)',
        textAlign: 'center',
        fontSize: '0.875rem',
        fontWeight: 400,
        lineHeight: '133%',
      },

      emptyHelpLink: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        color:
          theme.palette.mode === 'dark'
            ? 'var(--xlrt-color-future-green500)'
            : 'var(--xlrt-color-future-green800)',
        fontSize: '0.875rem',
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: 'normal',

        '& svg': {
          margin: 0,
        },
      },
    };
  },
  { name: 'EmptyView' },
);
